import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';


// StyleGuide = molecules/global/wysiwyg


/* eslint-disable-next-line react/display-name */
const WYSIWYG = forwardRef(({
  children,
  className = '',
  id,
  tabIndex
}, ref) => {
  const innerHTML = { __html: children };

  const accessibilityProps = { ...(tabIndex && { tabIndex }) };

  return (
    /* eslint-disable-next-line react/no-danger */
    <div {...accessibilityProps} id={id} className={`wysiwyg ${className}`} dangerouslySetInnerHTML={innerHTML} ref={ref} />
  );
});

WYSIWYG.propTypes = {
  children: PropTypes.string.isRequired,
  className: PropTypes.string,
  id: PropTypes.string,
  tabIndex: PropTypes.number
};

export default WYSIWYG;
